import React from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { TableCell } from 'semantic-ui-react';
import { AppState } from 'services/types';
import { SprayEventEntityId } from 'services/sprayEvents/types';
import { makeSelectEntityName } from './selectors';

export interface OwnProps {
    entityId: SprayEventEntityId;
    spraySchemaEntityId: SprayEventEntityId;
}

interface ConnectedProps {
    entityName: string;
}

type Props = OwnProps & ConnectedProps;

export class EntityTableRowNameCellComponent extends React.PureComponent<
    Props
> {
    render(): React.ReactElement {
        const { entityName } = this.props;

        return (
            <TableCell textAlign="left" className="events-table-cell-padding">
                {entityName}
            </TableCell>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    entityName: makeSelectEntityName()
});

export default connect(mapStateToProps)(EntityTableRowNameCellComponent);
